<template>
	<div class="main-layout">
		<navbar/>
		<maintenance-banner v-if="maintenanceStatus"/>
		<advisory-banner/>
		<div class="container mt-4">
			<child/>
		</div>

		<banner/>

		<sticky-footer/>
	</div>
</template>

<script>
	import Navbar from '~/components/Navbar'
	import Banner from '~/components/Banner'
	import StickyFooter from '~/components/StickyFooter'
	import MaintenanceBanner from '~/components/MaintenanceBanner'
	import AdvisoryBanner from '~/components/AdvisoryBanner'
	import {mapGetters} from 'vuex'

	export default {
		name: 'MainLayout',

		components: {
			Navbar, StickyFooter, Banner, MaintenanceBanner, AdvisoryBanner
		},

		data: () => ({
			maintenanceInterval: '',
			timeout: 80
		}),

		computed: {
			...mapGetters('maintenance', [
				'maintenanceStatus'
			])
		},

		methods: {
			checkForMaintenanceBanner() {
				this.$store.dispatch('maintenance/checkMaintenanceSchedule');
			},

			setIntervalForMaintenanceBanner() {
				this.maintenanceInterval = setInterval(() => {
					this.checkForMaintenanceBanner();
				}, this.timeout * 1000);
			}
		},

		mounted() {
			this.checkForMaintenanceBanner()
			this.setIntervalForMaintenanceBanner()
		},

		beforeDestroy() {
			clearInterval(this.maintenanceInterval)
		}
	}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/layouts/default.vue